import {
	GET_PROJECT_REGISTRATION,
	GET_BUDGET_REQUEST_INFO,
	CREATE_PROJECT_REGISTRATION,
	RESET_PROJECT_REGISTRATION_COMPLETED
} from '@/redux/actions/registration.actions'

const initialState = {
	loading: false,
	error: false,
	details: {},
	budgetRequest: {},
	completed: null
}

const details = (state = initialState.details, action) => {
	switch (action.type) {
		case GET_PROJECT_REGISTRATION.SUCCESS:
			return action.payload
		case GET_PROJECT_REGISTRATION.REQUEST:
			return {}
		case GET_PROJECT_REGISTRATION.FAILURE:
		default:
			return state
	}
}
const budgetRequest = (state = initialState.budgetRequest, action) => {
	switch (action.type) {
		case GET_BUDGET_REQUEST_INFO.SUCCESS:
			return action.payload
		case GET_BUDGET_REQUEST_INFO.REQUEST:
			return {}
		case GET_BUDGET_REQUEST_INFO.FAILURE:
		default:
			return state
	}
}

const loading = (state = initialState.loading, action) => {
	switch (action.type) {
		case GET_PROJECT_REGISTRATION.REQUEST:
		case GET_BUDGET_REQUEST_INFO.REQUEST:
			return true
		case GET_PROJECT_REGISTRATION.SUCCESS:
		case GET_PROJECT_REGISTRATION.FAILURE:
		case GET_BUDGET_REQUEST_INFO.SUCCESS:
		case GET_BUDGET_REQUEST_INFO.FAILURE:
			return false
		default:
			return state
	}
}

const error = (state = initialState.error, action) => {
	switch (action.type) {
		case GET_PROJECT_REGISTRATION.FAILURE:
			return true
		case GET_PROJECT_REGISTRATION.REQUEST:
		case GET_PROJECT_REGISTRATION.SUCCESS:
		case CREATE_PROJECT_REGISTRATION.REQUEST:
		case CREATE_PROJECT_REGISTRATION.SUCCESS:
			return false
		default:
			return state
	}
}

const completed = (state = initialState.completed, action) => {
	switch (action.type) {
		case CREATE_PROJECT_REGISTRATION.REQUEST:
		case RESET_PROJECT_REGISTRATION_COMPLETED:
			return null
		case CREATE_PROJECT_REGISTRATION.SUCCESS:
			return true
		case CREATE_PROJECT_REGISTRATION.FAILURE:
			return false
		default:
			return state
	}
}

export default {
	name: 'registration',
	reducers: {
		loading,
		error,
		details,
		completed,
		budgetRequest
	}
}
